<template>
  <div>
      <div class="box-title">
        {{ $t('Record.title') }}
      </div>
      <div class="trend-row">
        <el-button type="default" @click="dateRangeShiftLeft" icon="el-icon-caret-left" size="mini" ></el-button>
        <el-date-picker
          v-model="dateRange"
          size="small"
          class="filter-item"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="-"
          start-placeholder="開始日期"
          end-placeholder="結束日期">
        </el-date-picker>
        <el-button type="default" @click="dateRangeShiftRight" icon="el-icon-caret-right" size="mini"></el-button>
      </div>

      <div class="trend-row">
        <el-radio-group
          v-model="selectedSampling"
          size="small"
          type="primary" >
          <el-radio-button
            v-for="(value, key) in samplingOptions"
            v-show="showControl[key]"
            :key="key"
            :label="key"
            plain>
            {{ $t('Record.'+key) }}
          </el-radio-button>
        </el-radio-group>
        
        <p class="trend-p font-s">({{ $t('Record.weekHint') }})</p>
      </div>

      <p v-if="!chartDataExist" class="font-b font-df"> {{ $t('Record.empty') }} </p>

      <div>
        <div style="display: flex">
          <span :style="'flex: 0 0 2%; height:16px; background-color: #C13E3E'"></span> <span style="margin: 0px 5px;"> {{ $t('Record.reversed') }} </span>
          <span :style="'flex: 0 0 2%; height:16px; background-color: #ffb980'"></span> <span style="margin: 0px 5px;"> {{ $t('Record.notCompleted') }} </span>
          <span :style="'flex: 0 0 2%; height:16px; background-color: #FBD746'"></span> <span style="margin: 0px 5px;"> {{ $t('Record.replaced') }} </span>
        </div>
      </div>

      <div style="width:100%; height:400px">
        <v-chart
          :option="waterUseChart"
          :loading="chartsLoading"
          :theme="chartsTheme"
          :update-options="{ notMerge: true}"
          style="width: 100%; height:100%"
          autoresize />
      </div>
      <p class="font-s">{{ $t('Record.chartHint') }}</p>
  </div>
</template>
<script>
import { mixins } from '@/views/common/mixins.js'

export default {
  // 用水量查詢
  name: 'Record',
  mixins: [mixins],
  props: {
    // dialogVisible: {
    //   require: true,
    //   default: undefined,
    //   type: Boolean
    // },
    // profileData: {
    //   require: true,
    //   default: undefined,
    //   type: Object
    // }
    shareUVTU: String,
  },
  data() {
    return {
      listQuery: {
        start: this.getNDaysAgo(30, new Date()),
        end: this.parseDateTime(new Date().toISOString()),
        sampling: 'day'
      },


      // 日期元件 選擇的日期範圍
      dateRange: [this.getNDaysAgo(30, new Date()), this.parseDateTime(new Date().toISOString())],

      // sampling 選項
      samplingOptions: {
        'day': '日',
        'week': '週',
        'month': '月',
        'year': '年'
      },
      // 選擇的 sampling
      selectedSampling: '',

      // 圖表
      chartDataExist: false, // 是否有圖表資料
      xAxisData: [],
      seriesData: [],
      chartsLoading: false,

      // bar 異常顏色對應
      colorMap: {
        'reversed': '#C13E3E', // 逆轉, 紅
        'not completed': '#ffb980', // 數據不完整, 橘
        'replaced': '#FBD746' // 換表, 黃
      },
      showControl: {
        day: false,
        week: false,
        month: false,
        year: false
      }
    }
  },
  computed: {
    currentWaterId() {
      return JSON.parse(localStorage.getItem('currentProfile')).waterId
    },
    waterUseChart() {
      let _this = this
      let option = {
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            let warningStr = ''
            if (params[0].data.warning[0] == 'normal') {
              warningStr = `<p style="color: #4791DC; margin: 0"> ${_this.$t('Record.normal')} </p>`
            } else {
              params[0].data.warning.forEach(w => {
                if (w == 'reversed') {
                  warningStr += `<p style="color: #C13E3E; margin: 0"> ${_this.$t('Record.reversed')} </p>`
                }
                if (w == 'not completed') {
                  warningStr += `<p style="color: #FFAB66; margin: 0"> ${_this.$t('Record.notCompleted')} </p>`
                }
                if (w == 'replaced') {
                  warningStr += `<p style="color: #F5C105; margin: 0"> ${_this.$t('Record.replaced')} </p>`
                }

              })
            }

            return `<b>${_this.$t('Record.startTime')}:</b> ${params[0].data.startOn} <br/>
                    <b>${_this.$t('Record.endTime')}:</b> ${params[0].data.endOn} <br/>
                    <b>${_this.$t('Record.waterUsage')}:</b> ${params[0].data.value} <b>(${_this.$t('Record.m3')})</b> <br/>
                    ${warningStr}`
          },
        },
        xAxis: {
          type: 'category',
          data: _this.xAxisData
        },
        yAxis: {
          type: 'value',
          name: this.$t('Record.waterUsage')+'('+this.$t('Record.m3')+')'
        },
        series: [
          {
            data: _this.seriesData,
            type: 'bar',
            barMaxWidth: 20,
            label: {
              show: true,
              position: 'top',
              formatter: function(params) {
                 return params.data.value
              }
            }
          }
        ]
      }

      return option
    }

  },
  watch: {
    // dialogVisible() {
    //   this.listQuery = {
    //     start: this.getNDaysAgo(30, new Date()),
    //     end: this.parseDateTime(new Date().toISOString()),
    //     sampling: 'day'
    //   }
    //   // 日期元件 選擇的日期範圍
    //   this.dateRange = [this.getNDaysAgo(30, new Date()), this.parseDateTime(new Date().toISOString())]
    //   this.getData(this.profileData.waterId)
    // },
    // profileData(val) {
    //   this.getData(val.waterId)
    // },
    dateRange: function(val) {
      if (val) {
        this.listQuery.start = val[0]
        this.listQuery.end = val[1]
      } else {
        this.listQuery.start = undefined
        this.listQuery.end = undefined
      }
    //   this.getData(this.profileData.waterId)
    this.getData()
    },
    selectedSampling: function(val) {
      this.listQuery.sampling = val
    //   this.getData(this.profileData.waterId)
    this.getData()
    }
  },
  created() {
    // this.getData()
    console.log('Record shareUVTU:', this.shareUVTU)
    if (this.shareUVTU === 'hour' || this.shareUVTU === 'day') {
      this.showControl.day = true
      this.showControl.week = true
      this.showControl.month = true
      this.showControl.year = true
    } else if (this.shareUVTU === 'week') {
      this.showControl.week = true
      this.showControl.month = true
      this.showControl.year = true
    } else if (this.shareUVTU === 'month') {
      this.showControl.month = true
      this.showControl.year = true
    } else if (this.shareUVTU === 'year') {
      this.showControl.year = true
    }
    if (this.shareUVTU === 'hour'){
      this.selectedSampling = 'day'
    } else {
      this.selectedSampling = this.shareUVTU
    }
    console.log('selectedSampling', this.selectedSampling)
  },
  methods: {
    // dialogOnClose() {
    //   this.resetData()
    //   this.$emit('close')
    // },
    getData() {
      this.chartsLoading = true
      this.axios.get('/api/report/profile/' + this.currentWaterId + '/record', {params: this.listQuery }).then(res => {
        this.xAxisData = [] // 初始化 很重要!
        this.seriesData = []
        if (res.data.length > 0) {
          this.chartDataExist = true
          let data = res.data
          // console.log('data', data)
          data.forEach(element => {
            this.xAxisData.push(element.startOn)
            let warningList = [] // 發生哪些異常
            // 判斷要標啥顏色
            if (element.completed && !element.replaced && !element.reversed) { // 無異常, 無需標顏色
              warningList.push('normal')
              this.seriesData.push({
                startOn: element.startOn,
                endOn: element.endOn,
                value: element.volumeAdjusted != null ? element.volumeAdjusted.toFixed(2): (element.volume != undefined ? element.volume.toFixed(2): ''), // 若有人工調整指針 則呈現人工調整後的值,
                warning: warningList
                })
            } else { // 需標註顏色
              let barColor = this.evaluateColor(element.completed, element.replaced, element.reversed)
              if (!element.completed) {
                warningList.push('not completed')
              }
              if (element.reversed) {
                warningList.push('reversed')
              }
              if (element.replaced) {
                warningList.push('replaced')
              }
              this.seriesData.push({
                startOn: element.startOn,
                endOn: element.endOn,
                value: element.volumeAdjusted != null ? element.volumeAdjusted.toFixed(2): (element.volume != undefined ? element.volume.toFixed(2): ''), // 若有人工調整指針 則呈現人工調整後的值
                warning: warningList,
                itemStyle: {
                  color: barColor
                }
              })
            }
          });
        } else {
          this.chartDataExist = false // 無圖表資料
        }
        this.chartsLoading = false
      })
    },
    // 評估 bar 標註顏色
    evaluateColor(completed, replaced, reversed) {
      if (reversed) { // 只要有逆轉(reversed = true) 發生 標註紅色
        return this.colorMap['reversed']
      } else if (replaced) { // 只要有換表(replaced = true) 發生 標註黃色  (逆轉跟換表不會同時為true)
        return this.colorMap['replaced']
      } else if (!completed) { // 數據不完整(completed = false) 發生 標註橘色
        return this.colorMap['not completed']
      } else {
        return this.colorMap['normal']
      }
    },
    resetData() {
      this.xAxisData = []
      this.seriesData = []
      this.selectedSampling = 'day'
    },
    // 往右 shift
    dateRangeShiftRight() {
      const start = new Date(this.dateRange[0])
      const end = new Date(this.dateRange[1])

      let shiftDay = this.getShiftDayBySampling() // 依照選擇的 sampling 決定位移天數

      start.setDate(start.getDate() + shiftDay)
      end.setDate(end.getDate() + shiftDay)
      this.dateRange = [start.toISOString().slice(0, 10), end.toISOString().slice(0, 10)]
      
    },
    // 往左 shift
    dateRangeShiftLeft() {
      const start = new Date(this.dateRange[0])
      const end = new Date(this.dateRange[1])

      let shiftDay = this.getShiftDayBySampling() // 依照選擇的 sampling 決定位移天數
      
      start.setDate(start.getDate() - shiftDay)
      end.setDate(end.getDate() - shiftDay)
      this.dateRange = [start.toISOString().slice(0, 10), end.toISOString().slice(0, 10)]
    },
    // 依照選擇的 sampling 決定位移天數
    getShiftDayBySampling() {
      switch (this.selectedSampling) {
        case 'day':
          return 1
        case 'week':
          return 7
        case 'month':
          return 30
        case 'year':
          return 365
      }


    }

  }
}
</script>
